import type { useTranslations } from "next-intl";
import type { DiscountType } from "@/features/cart/types/discount.type";
import { getDiscountDetails } from "@/features/diets/helpers/get-discount-details";
import { getLocalePrice } from "@/lib/utilities";
import { cn } from "@/lib/utils";

export const DietListItemPrice = ({
  price,
  discountCodes,
  numberOfDays,
  t,
}: {
  price: number;
  discountCodes?: DiscountType[];
  numberOfDays?: number;
  t: ReturnType<typeof useTranslations>;
}) => {
  const { priceAfterDiscount } = getDiscountDetails({
    price,
    discountCodes,
    numberOfDays,
  });

  // A discount code can still resolve to no actual reduction; only a real one
  // moves the price to the discounted (red) slot.
  const discountedPrice =
    priceAfterDiscount && priceAfterDiscount !== price
      ? priceAfterDiscount
      : undefined;

  return (
    <p className="flex flex-wrap items-baseline gap-1 whitespace-nowrap">
      <span
        className={cn(
          "font-medium text-xl leading-7",
          discountedPrice ? "text-text-discount" : "text-text",
        )}
      >
        {t("diets.price_from_amount", {
          price: getLocalePrice({ price: discountedPrice ?? price }),
        })}
      </span>
      {discountedPrice && (
        <span className="text-base text-text-subtle leading-6 line-through">
          {getLocalePrice({ price })}
        </span>
      )}
      <span className="text-base text-text leading-6">{`/ ${t("diets.day")}`}</span>
    </p>
  );
};
